import React, { useEffect, useState } from 'react';

import {
    Box,
    Typography,
    Button,
    Dialog,
    TextField,
    IconButton,
    ListItemButton,
    ListItemText,
    ListItem,
    Chip,
    Skeleton,
    Grid,
    FormControlLabel,
    Switch,
    styled,
    AppBar,
    Toolbar
} from '@mui/material';

import Slide from '@mui/material/Slide';

import { useTheme } from '@mui/material/styles';
import { useFormik } from 'formik';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import CommonSectionHeader from '../../common/CommonSectionHeader';
import CommonRestricted from '../../common/CommonRestricted';

import { useAppContextFeatures } from '../../../context/AppContext';
import { validationSettingSchema } from "../../../schema/products/itemSchema";

import { useItems, itemTypes, targetTypes } from '../../../hooks/api/useItems';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

const StyledBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
}));

export default function UpdateItemSettings(
    { 
        routeType,
        id,
        handleOnSuccess,
    }
) {

    // const [ savedValues, setSavedValues ] = useState(loadValues)
    const [ savedValues, setSavedValues ] = useState()
    const { promptMessage } = useSystemPrompt()
    const { update, get } = useItems({ itemType: itemTypes.item, targetType: targetTypes.item });  
    const { setSystemLoading } = useAppContextFeatures()
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.item.id)
    
    const loadData = async (id) => {

        setSystemLoading(true);

        try{

            const { data } = await get({ id })

            const { 
                item,
            } = data;

            setSavedValues(prev => ({
                ...prev,
                codePrefix: item?.scanning_code_prefix? item.scanning_code_prefix : "",
                codeSuffix: item?.scanning_code_suffix? item.scanning_code_suffix : "",
                showCbm: item?.scanning_show_cbm === "1",
            }))

        }catch(error){
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try{
            let data = {
                props: {
                    scanning_code_prefix : currentValues?.codePrefix,
                    scanning_code_suffix : currentValues?.codeSuffix,
                },
                status: {
                    scanning_show_cbm : currentValues?.showCbm? 1 : 0,
                }
            }
    
            console.log('data', data)

            const response = await update({ id, data });
    
            promptMessage(true, `${response?.message}`)

            if(handleOnSuccess)
                handleOnSuccess();

        }catch(error){
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema: validationSettingSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;  

    useEffect(() => {
        loadData(id)
    }, [])

    const RenderForm = () => {
        return (
            <Box
                sx={{
                    p: 2,
                    pt: 0
                }}
            >
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                        <StyledBox>
                            <CommonSectionHeader
                                title='App Display'
                                subTitle='Change display style'
                            />
                        </StyledBox>                        
                        
                    </Grid>

                    <Grid item xs={12} sm={12} md={8}>
                        <Grid container spacing={0.5}>
                            <Grid item xs={12} sm={12} md={12}
                                sx={{
                                    display:'center',
                                    mt: 1
                                }}>
                                   
                                <FormControlLabel 
                                    control={
                                        <Switch 
                                            name="showCbm" 
                                            checked={Boolean(values?.showCbm)}
                                            onChange={(event, checked) => {
                                                setFieldValue("showCbm", checked);
                                            }}
                                        />
                                    }     
                                    label={
                                        Boolean(values?.showCbm)? "Show CBM" : "Hide CBM"
                                    }
                                />
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} textAlign={"left"}>     

                        <StyledBox>
                            <CommonSectionHeader
                                title='App Scanning'
                                subTitle='Alter data during scan'
                            />
                        </StyledBox>                        
                        
                    </Grid>

                    <Grid item xs={12} sm={12} md={8}>
                        <Grid container spacing={0.5}>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"codePrefix"}
                                    label="Prefix"
                                    type="text"                                         
                                    variant="outlined"
                                    value={values?.codePrefix? values.codePrefix:""}
                                    onChange={handleChange}
                                    error={touched.codePrefix && Boolean(errors.codePrefix)}
                                    helperText={touched.codePrefix && errors.codePrefix}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"codeSuffix"}
                                    label="Suffix"
                                    type="text"                                         
                                    variant="outlined"
                                    value={values?.codeSuffix? values.codeSuffix:""}
                                    onChange={handleChange}
                                    error={touched.codeSuffix && Boolean(errors.codeSuffix)}
                                    helperText={touched.codeSuffix && errors.codeSuffix}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </Box>
                        
        )
    }

    const RenderUpdateScan = () =>{
        return(
            
            <form 
                onSubmit={handleSubmit}
                style={{
                    height: '100%'
                }}
            > 
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '100%'
                        // alignItems: 'center'
                    }}
                >
                    <Box>
                        {
                            RenderForm()
                        }
                    </Box>

                    <Box
                        sx={{
                            m: 2,
                            textAlign: 'right'
                        }}
                    >
                        <Button
                            variant='contained'
                            // color='inherit'
                            type='submit'
                        >
                            Save Changes
                        </Button>
                    </Box>

                </Box>

            </form>  
        )
    }

    return (
        <Box
            sx={{
                height: '100%'
            }}
        >

            {
                isPermissionAllow({ functionType: functionTypes.pageSettings.id })?
                    RenderUpdateScan()
                    :
                    <CommonRestricted />
            }

        </Box>

    )

}